export type EnvelopesState = {
  myEnvelopesPending: boolean;
  myEnvelopes: any[] | null;
  myEnvelopesError: string | null;
};

export const state: EnvelopesState = {
  myEnvelopesPending: false,
  myEnvelopes: null,
  myEnvelopesError: null,
};